module.exports = __webpack_public_path__ + "static/img/Store-19.0497480e.png";